import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { colors } from '@mui/material';
import _ from 'underscore';
import moment from 'moment';
import ModalDialog from '../../../../components/ModalDialog/ModalDialog';
import StreetScapeTrackerDialogFormCreate from './StreetScapeTrackerDialogFormCreate';
import SreetScapeTrackerDialogFormEdit from './StreetScapeTrackerDialogFormEdit';

import { SetFormState, ToggleStreetScapeTrackerDialog, CreateStreetScapeEntry, EditStreetScapeEntry } from '../../actions/StreetScapeTrackerActions';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 960,
	},
	header: {
		padding: theme.spacing(3),
		maxWidth: 720,
		margin: '0 auto',
	},
	content: {
		padding: theme.spacing(0, 2),
		maxWidth: 720,
		margin: '0 auto',
	},
	helperText: {
		textAlign: 'right',
		marginRight: 0,
	},
	author: {
		margin: theme.spacing(4, 0),
		display: 'flex',
	},
	avatar: {
		marginRight: theme.spacing(2),
	},
	actions: {
		backgroundColor: colors.grey[100],
		padding: theme.spacing(2),
		display: 'flex',
		alignContent: 'right',
	},
	applyButton: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	},
}));

const SreetScapeTrackerDialog = (props) => {
	const classes = useStyles();
	const { onClose, open, streetScapeTrackerId, ...rest } = props;
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector((state) => state.streetScapeTrackerReducer.formState);
	const user = useSelector(state => state.session.user.id);
	const streetScapeTrackerTable = useSelector((state) => state.streetScapeTrackerReducer.streetScapeTrackerTable);
	const selectedSite = streetScapeTrackerTable.find(obj => obj.id === streetScapeTrackerId);

	const _onConfirmClick = () => {
		setFormState({ ...formState, submit: true });
		if (formState.isValid && streetScapeTrackerId === 0) {
			dispatch(CreateStreetScapeEntry({ ...formState.values, user }));
			dispatch(ToggleStreetScapeTrackerDialog(false, 0));
		} else if (formState.isValid) {
			if (formState.values.activationStatus === 'Rescheduled') {
				formState.values.activationStatus = 'Cancelled';
				dispatch(EditStreetScapeEntry({ ...formState.values, user }));
				formState.values.activationDate = formState.values.rescheduledDate;
				formState.values.activationStatus = 'Scheduled';
				dispatch(CreateStreetScapeEntry({ ...formState.values, user }));
			} else {
				dispatch(EditStreetScapeEntry({ ...formState.values, user }));
			}
			dispatch(ToggleStreetScapeTrackerDialog(false, 0));
		}
	};

	const _getTitleLabel = () => {
		if (streetScapeTrackerId === 0) {
			return 'Create';
		}
		if (selectedSite.currentStatus !== 'Complete') {
			return 'Edit';
		}
		return 'View';
	};

	const _checkCurrentStatus = () => {
		if (streetScapeTrackerId === 0) {
			return true;
		}
		if (selectedSite.currentStatus !== 'Complete') {
			return true;
		}
		return false;
	};

	return (
		<ModalDialog
			onClose={onClose}
			title={_getTitleLabel()}
			open={open}
			confirmLabel={streetScapeTrackerId !== 0 ? 'Edit' : 'Create'}
			onConfirmClicked={_onConfirmClick}
			maxWidth="xl"
			hasConfirm={_checkCurrentStatus()}
			cancelLabel={(streetScapeTrackerId !== 0 && selectedSite.currentStatus === 'Complete') ? 'Close' : 'Cancel'}
		>
			{streetScapeTrackerId === 0 ? (
				<StreetScapeTrackerDialogFormCreate />
			) : (
				<SreetScapeTrackerDialogFormEdit streetScapeTrackerId={streetScapeTrackerId} />
			)}
		</ModalDialog>
	);
};

SreetScapeTrackerDialog.propTypes = {
	onClose: PropTypes.func,
	open: PropTypes.bool.isRequired,
	streetScapeTrackerId: PropTypes.number,
	submitter: PropTypes.string,
	currentStatus: PropTypes.string,
};

export default SreetScapeTrackerDialog;
